import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';


const reducer = (state, action) => {
    switch (action.type) {
        case "SET_SESION_USER":
            return {
                ...state,
                usuario: action.usuario,
            }

        case "QUERY_USER":
            return {
                ...state,
                QUERY_USER: action.QUERY_USER,
            }
        case "CHANGE_DIMENSIONS_APP":
            return {
                ...state,
                configApp: { ...state.configApp, width: action.width, height: action.height }
            }

        case "UPDATE_IDIOMA_SERTEC":
            return {
                ...state,
                idiomaActual: action.idiomaActual
            }

        case "STATE_ACTIVEITEM_REFERENCIA":
            return {
                ...state,
                activeItemReferencia: action.activeItemReferencia
            }

        case "STATE_REGISTRO_NOTICIA":
            return {
                ...state,
                registroNoticia: action.registroNoticia
            }
        case "STATE_DRAWER_FICHA_IMPRESION_DOCUMENTO":
            return {
                ...state,
                estadoDrawer: { ...state.estadoDrawer, openDrawerFichaImpresionDocumento: action.openDrawerFichaImpresionDocumento }
            }
    }

    return state;
};



const logger = store => next => action => {
    if (window.location.hostname === "licencias.servicenext.eu") {
        let result = next(action)
        return result;
    } else {
        //console.log('dispatching', action)
        let result = next(action)
     //   console.log('next state', store.getState());
        return result;
    }
}


export default createStore(reducer, {
    usuario: {},
    QUERY_USER: {},
    configApp: {
        width: 0,
        height: 0,
        visualizacionDescuento: true,
        visualizacionFiltro: true,
        visualizacionGrafico: true
    },
    estadoDrawer: {
        openDrawerHistoricoCoche: false,
        openDrawerCarroCompra: false,
        openDrawerMasInfo: false,
        openDrawerMasInfo2: false,
        openDrawerStockAlmacen: false,
        openDrawerReferenciaGrafico: false,
        openDrawerHaynesPro: false,
        openDrawerPerfilUsuario: false,
        openDrawerNextAssist: false,
        openDrawerAcademyCloud: false,
        openDrawerFichaCliente: false,
        openDrawerFichaCocheDGT: false,
        openDrawerFichaClienteTaller: false,
        openDrawerFichaUsuarios: false,
        openDrawerFichaClienteSocio: false,
        openDrawerFichaMantenimientoCliente: false,
        openDrawerFichaMantenimientoVehiculo: false,
        openDrawerFichaPresupuestoTaller: false,
        openDrawerFichaAlbaranesTaller: false,
        openDrawerFichaDatosClientes: false,
        openDrawerFichaMarcasVehiculo: false,
        openDrawerFichaReferenciaVehiculo: false,
        openDrawerFichaEquivalenciaArticulo: false,
        openDrawerFichaMantenimientoPresupuesto: false,
        openDrawerEmpresa: false,
        openDrawerFichaVehiculoCliente: false,
        openDrawerFichaManoObra: false,
        openDrawerFichaArticulo: false,
        openDrawerFichaImpresionDocumento: false,
        openDrawerFichaEnvioDocumento: false,
        openDrawerFichaTiemposReparacion: false,
        openDrawerFichaGMYVehiculoHaynesPro: false,
        openDrawerFichaMantenimientoHaynesPro: false

    },
    idiomaActual: {},
    activeItemReferencia: "",
    registroNoticia: {},
}, applyMiddleware(logger, thunk));
